import React, { useState } from 'react';

import { useSelectableWritingPlans } from 'src/hooks/writing-plans';
import DialogSharedLayout from '../../shared/Dialogs/Layout';
import { Description } from '../../typography';

import { WritingPlanSelectionDialogProps } from './types';
import {
  WritingPlanButton,
  WritingPlanDialogContent,
  ContentContainer,
  EmptyWritingPlan,
} from './styles';
import { RocketLaunchingImg } from '../../../assets/images';
import { lang } from '../../../lang';
import WritingPlanInfo from '../../WritingPlan/Info';

function WritingPlanSelectionDialog({
  onSkip,
  onAdd,
  onClickBack,
  initialWritingPlan = '',
}: WritingPlanSelectionDialogProps) {
  const writingPlans = useSelectableWritingPlans();
  const [selectedPlan, setSelectedPlan] = useState(initialWritingPlan);

  const currentWritingPlanDisplayed = writingPlans.find((plan) => plan.id === selectedPlan);

  return (
    <DialogSharedLayout
      titleLangKey="document.create_pressto_dialog.writing_plan.title.line_1"
      subtitleLangKey="document.create_pressto_dialog.writing_plan.title.line_2"
      handleSkip={onSkip}
      handleSave={() => onAdd(selectedPlan)}
      handleBack={onClickBack}
    >
      <WritingPlanDialogContent>
        <div className="tab-container">
          <WritingPlanButton
            onClick={() => setSelectedPlan('')}
            selected={!selectedPlan}
          >
            None
          </WritingPlanButton>
          {writingPlans.map((plan) => (
            <WritingPlanButton
              key={plan.id}
              onClick={() => setSelectedPlan((prev) => (prev === plan.id ? '' : plan.id))}
              selected={selectedPlan === plan.id}
            >
              {plan.title}
            </WritingPlanButton>
          ))}
        </div>
        <ContentContainer>
          {
            currentWritingPlanDisplayed && selectedPlan ? (
              <WritingPlanInfo
                key={selectedPlan}
                writingPlan={currentWritingPlanDisplayed}
              />
            ) : (
              <EmptyWritingPlan>
                <img
                  src={RocketLaunchingImg}
                  alt={lang('document.create_pressto_dialog.writing_plan.no_plan_selected')}
                />

                <Description align="center">
                  {lang('document.create_pressto_dialog.writing_plan.no_plan_selected')}
                </Description>
              </EmptyWritingPlan>
            )
          }
        </ContentContainer>
      </WritingPlanDialogContent>
    </DialogSharedLayout>
  );
}

export default WritingPlanSelectionDialog;
